module.exports = __webpack_public_path__ + "img/user-location.58f07df2.svg";